module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.a8050944.svg";